

const getDrawDirection = (x, y, x1, y1) => {
  const xDirection = x > x1 ? 'right-to-left' : 'left-to-right'
  const yDirection = y > y1 ? 'bottom-to-top' : 'top-to-bottom'

  return `${xDirection}-${yDirection}`;
}

const getLineAngles = (x, y, x1, y1) => {
  const angle = ((Math.atan2(y - y1, x - x1) * 180 / Math.PI) - 180) * -1;
  const quadrant =Math.floor(angle / 90);
  const relativeAngles = {
    0: angle,
    1: 180 - angle,
    2: angle - 180,
    3: 360 - angle
  }
  const relativeAngle = relativeAngles[quadrant];

  return { angle: angle, relativeAngle: relativeAngle };
}

export { getDrawDirection, getLineAngles }